
import React from "react"
import { Link } from "react-router-dom";
import { useState } from "react";
const AuditTrails =()=>{
    const MyNotification  = JSON.parse(localStorage.getItem('notification'));
    const [Cnotification, FnNotification]= useState(MyNotification)
    return(
        <div className=" gallery-popupdiv">
        <div className="container-fluid">
            <div className="form-head displayset">
                <div className="me-auto">
                    <h2 className="font-w600 mb-0">Audit Trails</h2>
                </div>
                <div className="form-head">
            <div className="input-group search-area2 d-xl-inline-flex mb-2">
                <button className="input-group-text"><i className="fa fa-search text-primary"></i></button>
                <input type="text" className="form-control" placeholder="Search here..."/>
            </div>
        </div>
            </div>
            <div className="timeline-wrapper">
                    <div className="timeline-header"></div>
                    <div className="timeline-wrapper-inner">
                        <div className="timeline-container">
                            <div className="timeline-item is-unread">
                                <div className="date">
                                    <span>Sep 23, 2020</span>
                                </div>
                                <div className="dot is-info"></div>
                                <div className="content-wrap">
                                    <div className="content-box">
                                        <div className="status"></div>
                                        <div className="h-avatar">
                                            <img className="avatar" src="images/org-img/notification/noti1.jpg" data-demo-src="images/org-img/notification/noti1.jpg" alt="" data-user-popover="6" data-target="webuiPopover3"/>
                                        </div>
                                        <div className="box-text">
                                            <div className="meta-text">
                                                <p><span>Tara S.</span> added you to the <a>Barber Website Redesign
                                                        Project</a>.</p>
                                                <span>11:42 am</span>
                                            </div>
                                        </div>
                                       
                                    </div>
                                </div>
                            </div>
                            <div className="timeline-item is-unread">
                                <div className="date">
                                    <span>Sep 23, 2020</span>
                                </div>
                                <div className="dot is-danger"></div>
                                <div className="content-wrap">
                                    <div className="content-box">
                                        <div className="status"></div>
                                        <div className="h-avatar">
                                            <img className="avatar" src="images/org-img/notification/noti.jpg" data-demo-src="images/org-img/notification/noti.jpg" alt="" data-user-popover="21"/>
                                        </div>
                                        <div className="box-text">
                                            <div className="meta-text">
                                                <p><span>Irina V.</span> left a comment on a <a>Task</a>, in <a>Corporate Tools Rebranding</a>.</p>
                                                <span>9:18 am</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="timeline-item">
                                <div className="date">
                                    <span>Sep 22, 2020</span>
                                </div>
                                <div className="dot is-success"></div>
                                <div className="content-wrap">
                                    <div className="content-box">
                                        <div className="status"></div>
                                        <div className="h-avatar">
                                            <img className="avatar" src="images/org-img/notification/noti1.jpg" data-demo-src="images/org-img/notification/noti1.jpg" alt="" data-user-popover="9"/>
                                        </div>
                                        <div className="box-text">
                                            <div className="meta-text">
                                                <p><span>Mary L.</span> added 3 new members to the <a>Blake &amp; Mortimer
                                                        Project</a>.</p>
                                                <span>9:18 am</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="timeline-item">
                                <div className="date">
                                    <span>Sep 23, 2020</span>
                                </div>
                                <div className="dot is-purple"></div>
                                <div className="content-wrap">
                                    <div className="content-box">
                                        <div className="status"></div>
                                        <div className="h-avatar">
                                            <img className="avatar" src="images/org-img/notification/noti1.jpg" data-demo-src="images/org-img/notification/noti1.jpg" alt="" data-user-popover="2"/>
                                        </div>
                                        <div className="box-text">
                                            <div className="meta-text">
                                                <p><span>Joshua S.</span> changed the status of a <a>Task</a>
                                                </p>
                                                <span>9:18 am</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="timeline-item">
                                <div className="date">
                                    <span>Sep 22, 2020</span>
                                </div>
                                <div className="dot is-warning"></div>
                                <div className="content-wrap">
                                    <div className="content-box">
                                        <div className="status"></div>
                                        <div className="h-avatar">
                                            <img className="avatar" src="images/org-img/notification/noti1.jpg" data-demo-src="images/org-img/notification/noti1.jpg" alt="" data-user-popover="23"/>
                                        </div>
                                        <div className="box-text">
                                            <div className="meta-text">
                                                <p><span>Courtney W.</span> uploaded 2 new files to the <a>Blake &amp; Mortimer
                                                        Project</a>.</p>
                                                <span>9:18 am</span>
                                            </div>
                                        </div>
                                       
                                    </div>
                                </div>
                            </div>
                            <div className="timeline-item">
                                <div className="date">
                                    <span>Sep 23, 2020</span>
                                </div>
                                <div className="dot is-info"></div>
                                <div className="content-wrap">
                                    <div className="content-box">
                                        <div className="status"></div>
                                        <div className="h-avatar">
                                            <img className="avatar" src="images/org-img/notification/noti1.jpg" data-demo-src="images/org-img/notification/noti1.jpg" alt="" data-user-popover="27"/>
                                        </div>
                                        <div className="box-text">
                                            <div className="meta-text">
                                                <p><span>Yassine A.</span> mentionned you in a <a>comment</a> on <a>Delivery tracking Dashboard</a>.</p>
                                                <span>11:42 am</span>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                            <div className="timeline-item">
                                <div className="date">
                                    <span>Sep 23, 2020</span>
                                </div>
                                <div className="dot is-danger"></div>
                                <div className="content-wrap">
                                    <div className="content-box">
                                        <div className="status"></div>
                                        <div className="h-avatar">
                                            <img className="avatar" src="images/org-img/notification/noti1.jpg" data-demo-src="images/org-img/notification/noti1.jpg" alt="" data-user-popover="6"/>
                                        </div>
                                        <div className="box-text">
                                            <div className="meta-text">
                                                <p><span>Tara S.</span> left a comment on a <a>Task</a>, in <a>Corporate Tools Rebranding</a>.</p>
                                                <span>9:18 am</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="timeline-item">
                                <div className="date">
                                    <span>Sep 23, 2020</span>
                                </div>
                                <div className="dot is-purple"></div>
                                <div className="content-wrap">
                                    <div className="content-box">
                                        <div className="status"></div>
                                        <div className="h-avatar">
                                            <img className="avatar" src="images/org-img/notification/noti1.jpg" data-demo-src="images/org-img/notification/noti1.jpg" alt="" data-user-popover="4"/>
                                        </div>
                                        <div className="box-text">
                                            <div className="meta-text">
                                                <p><span>Melany W.</span> changed the status of a <a>Task</a> from
                                                    <small className="tag is-rounded is-danger">Overdue</small> to
                                                    <small className="tag is-rounded is-green">Completed</small>
                                                </p>
                                                <span>9:18 am</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="load-more-wrap has-text-centered">
                            <button className="button h-button is-dark-outlined">Load More</button>
                        </div>
                    </div>
                </div>            
        </div>
    </div>
    )
}
export default AuditTrails;